module.exports = __webpack_public_path__ + "img/soft-bg-3-dark.010390f3.png";